import { call, put, select, takeEvery } from 'redux-saga/effects';
import axios from '../axiosConfig';
import { getCarRateRulesRequest, getCarRateRulesSuccess } from '../../slices/car';

const queryString = require('query-string');

function* getCarRateRulesWorker({ payload: { itinerary, key } }) {
  // Cache key comes from the dispatcher (built by getCarRateRulesCacheKey) so
  // that the success/failure dispatch ends up in the same slot the request
  // reducer marked as SEARCHING. Falls back to uniqueKey if no key was passed.
  const cacheKey = key || (itinerary && itinerary.uniqueKey);
  try {
    const { currencyCode } = yield select((store) => store.tripSearch);
    const { matchingMembershipCodes } = itinerary.priceInfo;
    const queryParams = {
      pickupDateTime: itinerary.pickUpDateTime,
      returnDateTime: itinerary.dropOffDateTime,
      SIPP: itinerary.carDetails.vehicleType,
      bookingProviderCode: itinerary.bookingProviderInfo.bookingProviderCode,
      originLocationCode: itinerary.locationInfo.originLocationCode,
      originLocationExtendedCode: itinerary.locationInfo.originLocationExtendedCode,
      destLocationCode: itinerary.locationInfo.destLocationCode,
      destLocationExtendedCode: itinerary.locationInfo.destLocationExtendedCode,
      rateCode: itinerary.priceInfo.rateCode,
      currencyCode: itinerary.priceInfo.currencyCode || currencyCode,
      rateCodes:
        matchingMembershipCodes && matchingMembershipCodes.length > 0
          ? matchingMembershipCodes
          : undefined,
    };

    // The rateToken is a long string like "X0000X000000000000000000000000".
    // Browser behaviour bug - applying stringify to rateToken changes it to cases like "XMCWNX9B6L".
    // Therefore explicitly appending rateToken at the end to keep it as is.
    const url = `/rentalcars/getCarRateRules?${queryString.stringify(queryParams)}&rateToken=${itinerary.priceInfo.rateToken}`;

    const config = {
      method: 'get',
      url,
    };
    const { data } = yield call(axios, config);
    if (data) {
      yield put(
        getCarRateRulesSuccess({
          key: cacheKey,
          vendorMessages: data.vendorMessages ?? data,
          carRateRules: data.vendorMessages ? data : null,
        }),
      );
    } else {
      yield put(
        getCarRateRulesSuccess({
          key: cacheKey,
          vendorMessages: {},
          carRateRules: null,
        }),
      );
    }
  } catch (error) {
    console.error('getCarRateRulesWorker error', error);
    yield put(
      getCarRateRulesSuccess({
        key: cacheKey,
        vendorMessages: {},
        carRateRules: null,
      }),
    );
  }
}

function* getCarRateRulesWatcher() {
  yield takeEvery(getCarRateRulesRequest.toString(), getCarRateRulesWorker);
}

export default getCarRateRulesWatcher;
